import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AppRouterService {

  constructor(private router: Router) { }

  goto(route: { path: string; params?: any }) {
    this.router.navigate([route.path])
  }

  gotoPath(path) {
    this.router.navigateByUrl(path)
  }
}
